/**
 * Phase 83-05 (PRREC-03) — derives the printer-offline kiosk subset.
 *
 * A kiosk counts when `printer_offline === true` (an EXPECTED printer is down;
 * the backend sets/clears the flag from the kiosk's printer_offline alarm and
 * broadcasts it over /ws/v1/fleet — see machine_service.set_printer_offline).
 * NON-BLOCKING + TELEMETRY-ONLY: this hook only surfaces the subset for the
 * Topbar badge + per-row indicator — it never triggers any action.
 *
 * Spreads `...machines` so consumers get the full TanStack contract
 * (isLoading, isError, refetch). The live update path needs no extra code:
 * useFleetWebSocket merges `machine_update` fields (incl. printer_offline)
 * into the machines cache, so the derived subset re-evaluates automatically.
 *
 * Mirrors useStaleKiosks (Phase 67-01 layer (d)).
 */

import { useMemo } from "react";

import { useMachines } from "@/hooks/queries/useMachines";

export function usePrinterOfflineKiosks() {
  const machines = useMachines();
  const filtered = useMemo(() => {
    if (!machines.data) return undefined;
    return machines.data.filter((m) => m.printer_offline === true);
  }, [machines.data]);

  return {
    ...machines,
    data: filtered,
  };
}
